
(function(){
	var app1 = angular.module('iq_common');

	app1.filter("bytes", function(){
	return function(value, express){
		return BYTES.bytes(value,express);
	};
})
	.filter("iq_html2text",function(){
		/**
		 * {{ XXX | iq_html2text }}
		 */
		return function(key){
			if(key){
				return key.replace(/<[^<]+>/g,"").replace(/&nbsp;/g," ");
			}
			return key;
		}
	})
	.filter("iq_flowstatus_display",function(){

//        FLOW_STATE_INIT: 0, //流程状态标记 - 初始化中 草稿
//        FLOW_STATE_ACTIVE: 1, //流程状态标记 - 启用中
//        FLOW_STATE_END: 3, //流程状态标记 - 结束
//        FLOW_STATE_WAITING: 4, //流程状态标记 - 等待
//        FLOW_STATE_REJECT_TO_START: 5, //流程状态标记 - 驳回到开始
//        FLOW_STATE_RETURN_TO_START: 6, //流程状态标记 - 撤回到开始
		/**
		 * {{ XXX | iq_flowstatus_display}}
		 */
		var display_list = ["开始","","草稿","已完成","","已拒绝","已撤回"]
		return function(obj){
			if(angular.isString(obj) || angular.isNumber(obj)){
				return display_list[obj]||"";
			}else{
				if(obj && obj.flowStatus!==undefined){
					if(obj.flowStatus == "1"){//如果是启用中，显示环节名称
						 return obj.flowCurrNodeName || "";
					}else{
						return display_list[obj.flowStatus]||"";
					}
				}
			}
		}
	})

	/**
	 * 传入时间与当前时间比较返回显示结果，如果XX>24h返回 '年-月-日 时：分'，如果24h>=XX>=1h返回'XX小时之前'，如果1h>XX 则返回'XX分钟之前'
	 * @returns {String} eg：1分钟之前
	 */
	app1.filter("iq_timecmprnow",['$filter',function($filter){
		/**
		 * {{ XXX | iq_timecmprnow }}
		 */
		return function(key){
			var _m = moment(key);
			var _d = new Date() - 3*86400000//3天前
			if(key>_d){
				return _m.fromNow();
			}else{
				return _m.format("l HH:mm");
			}
//			//TODO 时间从后台获取，在前台保存，单独计时。暂时使用浏览器时间
//			var currDate = new Date();
//			var operaDate = key;
//
//			if(currDate == null)
//				return "";
//			if(operaDate == null)
//				return "";
//			if(typeof operaDate == 'number'){
//				operaDate=new Date(operaDate);
//			}else if(typeof operaDate == 'string'){
//				try{
//					var _operaDate = parseDate(operaDate);
//					operaDate = _operaDate;
//				}catch(e){
//
//				}
//			}
//			if((currDate-operaDate)/1000/60 < 1){
//				return "1分钟前";
//			}else if((currDate-operaDate)/1000/60 >= 1 && (currDate-operaDate)/1000/60 < 60){
//				var time = (currDate-operaDate)/1000/60
//				time = time.toString().split(".")[0];
//				return time+"分钟前";
//			}else if((currDate-operaDate)/1000/60/60 >= 1 && (currDate-operaDate)/1000/60/60 <24){
//				var time = (currDate-operaDate)/1000/60/60;
//				time = time.toString().split(".")[0];
//				return time+"小时前";
//			}else{
//				var monthView = (operaDate.getMonth()+1) < 10 ? ("0" + (operaDate.getMonth()+1)) : (operaDate.getMonth()+1);
//				var dayView = operaDate.getDate() < 10 ? ("0" + operaDate.getDate()) : operaDate.getDate() ;
//				var hourView = operaDate.getHours() < 10 ? ("0" + operaDate.getHours()) : operaDate.getHours() ;
//				var minView = operaDate.getMinutes() < 10 ? ("0" + operaDate.getMinutes()) : operaDate.getMinutes() ;
//				return operaDate.getFullYear() + "-" + monthView + "-" + dayView + " " + hourView + ":" + minView;
//			}
		}
	}])
	app1.filter("iq_array_refactor",function(){
    	/*
    	 * 示例：{{ XXX | iq_array_refactor:"[.id][.name]"}}
    	 * XXX为数组[obj1,obj2]
    	 * 将按照expression的模式显示数组  其中[.属性]替换数组元素的属性值
    	 * id name为可选，也可替换
    	 * 如 任意1[.id]任意2[.name]任意3 显示 : 任意1+"obj1.id"+任意2+"obj1.name"+任意3,任意1+"obj2.id"+任意2+"obj2.name"+任意3
    	 *
    	 * XXX 为[{id:"id1",username:"xuchao1"},{id:"id2",username:"xuchao2"},{id:"id2",username:"xuchao2"}]
    	 * expression为[.username]([.id])
    	 * 显示结果为：xuchao1(id1),xuchao2(id2),xuchao2(id2)
    	 */
	    return function(array,expression){
//	        console.log(array)
	        var list = [];
	        var matchs = expression.match(/\[.[.\w]+\]/g);
	        var replaces = [];
	        for(var j = 0;j<matchs.length;j++){
	            var sub = matchs[j].slice(1,-1);
	            replaces.push(sub.split("."));
	        }
	        for(var i = 0;i<array.length;i++){
	            var str = expression;
	            for(var j = 0;j<matchs.length;j++){
	                var subs = replaces[j]
	                var tmp = array[i];
	                for(var k = 0;k<subs.length;k++){
	                    if(subs[k]&&tmp){
	                        tmp = tmp[subs[k]];
	                    }
	                }
	                str = str.replace(matchs[j],tmp);
	            }
	            list.push(str);
	        }
	        return list.join(",")
	    }
	})
	app1.filter("departmentfilter",function(){
		return function(key,expression){
			if(angular.isArray(key)){
				var tmp = [];
				for(var i = 0;i<key.length;i++){
					if(key[i].department && key[i].department.id == expression){
						tmp.push(key[i]);
					}
				}
				return tmp;
			}else{
				if(key.department && key.department.id == expression){
					return key;
				}else{
					return null;
				}
			}
		}
	})
    app1.filter("iq_refactor", function() {
    	/*
    	 * 示例：{{ XXX | iq_refactor:"男,true;女,false"}}
    	 * array_str pattern val,key;val,key;key,value
    	 */
    	var refactor = function(key,expression){
    		if(angular.isString(expression)){
	    		key += "";
	    		var tmp = expression+";";
	    		if(!!key){

		    		var r = new RegExp("([^;,]+),"+key+";")
		    		var result = tmp.match(r);
		    		if(result){
		    			return result[1];
		    		}
	    		}
    		}else if(!!expression && !!expression.value && expression.formula != true){
	    		key += "";

	    		if(!!key){
	    			if(angular.isString(expression.value)){
		    			var separator1 = expression.separator1 || ",";
		    			var separator2 = expression.separator2 || ";";
			    		var tmp = expression.value;
		    			var list = tmp.split(separator2);
		    			for(var i = 0;i < list.length;i++){
		    				var list1 = list[i].split(separator1);
		    				if(list1[1] == key){
		    					return list1[0];
		    				}
			    		}
	    			}else if(angular.isObject(expression.value)){
	    				var tmp = angular.copy(expression.value)
	    				for(var i in tmp){
	    					if(tmp[i]==key){
	    						return i;
	    					}
	    				}
	    			}
	    		}
	    		if(expression.def_val){
	    			return expression.def_val;
	    		}
    		}else if(!!expression && !!expression.value && expression.formula == true){
    			//使用key的表达式，匹配第一个满足的表达式，返回对应显示值
	    		key += "";

	    		if(!!key){
	    			if(angular.isString(expression.value)){
		    			var separator1 = expression.separator1 || ",";
		    			var separator2 = expression.separator2 || ";";
			    		var tmp = expression.value;
		    			var list = tmp.split(separator2);
		    			for(var i = 0;i < list.length;i++){
		    				var list1 = list[i].split(separator1);
		    				var result = eval(list1[1]);
		    				if(result){
		    					return list1[0];
		    				}
			    		}
	    			}
	    			else if(angular.isObject(expression.value)){
	    				var tmp = angular.copy(expression.value)
	    				for(var i in tmp){
	    					var result = eval(tmp[i]);
	    					if(result){
	    						return i;
	    					}
	    				}
	    			}
	    		}
	    		if(expression.def_val){
	    			return expression.def_val;
	    		}
    		}
    		return ""
    	}
    	return refactor;
    })
    //金钱转大写汉字
    app1.filter("iq_num2CN",function(){
    	var TransformNumberIntoCHN = function(themoney) {
    		var money = themoney+'';
    		var flag = 1;  //正负钱数标志位，1--正数，0--负数
    		var arr = new Array();
    		arr = money.split(".");
    		var intpart = arr[0].replace(/(.)(?=[^$])/g,"$1,").split(",");
    		if(intpart[0] === '-'){
    			flag = 0;
    			var str = "";
    			for(var i=1;i<intpart.length;i++){
    				str += intpart[i];
    			}
    			if(arr[1] !== '' || arr[1] !== null){
    				money = str+"."+arr[1];
    			}
    			else{
    				money = str;
    			}
    		}

    		if(money == '0.00' || money == '0'){
    			return "零元整";
    		}
    		else{
    			var number = money;
        	    var unit = "仟佰拾亿仟佰拾万仟佰拾元角分", str = "";
        	    number += "00";
        	    var point = number.indexOf('.');
        	    if (point >= 0) {
        	        number = number.substring(0, point) + number.substr(point + 1, 2);
        	    }
        	    unit = unit.substr(unit.length - number.length);
        	    for (var i = 0; i < number.length; i++) {
        	        str += '零壹贰叁肆伍陆柒捌玖'.charAt(number.charAt(i)) + unit.charAt(i);
        	    }
        	    //document.getElementById(idCHN).value = str.replace(/零(仟|佰|拾|角)/g, "零").replace(/(零)+/g, "零").replace(/零(万|亿|元)/g, "$1").replace(/(亿)万|壹(拾)/g, "$1$2").replace(/^元零?|零分/g, "").replace(/元$/g, "元整");
        	    var moneyCN = str.replace(/零(仟|佰|拾|角)/g, "零").replace(/(零)+/g, "零").replace(/零(万|亿|元)/g, "$1").replace(/(亿)万|(拾)/g, "$1$2").replace(/^元零?|零分/g, "").replace(/元$/g, "元整");
        	    if(flag === 0){
        	    	moneyCN = '负'+moneyCN;
        	    }
        	    return moneyCN;
    		}
    	}
    	return TransformNumberIntoCHN;
    })

    //按照关键字查询，关键字更加em标签高亮显示
    app1.filter("iq_choiceEM",function($sce){
    	var TransformEmStyle = function(expression,key) {
    		if(!expression){
//    			return '';
    		}
    		if(!key){
    			return expression;
    		}
    		var reg=new RegExp(key,"g");
			var t=expression.replace(reg,"<em>"+key+"</em>");
			return $sce.trustAsHtml(t)
    	}
    	return TransformEmStyle;
    })
    app1.filter("iq_popChoice",function(){
    	return function(data,filterStr){
    		var tempAry = [];
				if(!data){
    			return tempAry;
    		}
    		for(var i=0;i<data.length;i++){
					if(data[i].itcode == null && data[i].name != null && data[i].pinyin == null){
						if((data[i]&&data[i].name&&data[i].name.indexOf(filterStr)>=0)){
							tempAry.push(data[i]);
						}
					}
					if(data[i].itcode == null && data[i].name != null && data[i].pinyin != null){
						if((data[i]&&data[i].name&&data[i].name.indexOf(filterStr)>=0) || (data[i]&&data[i].name&&data[i].pinyin.indexOf(filterStr)>=0)){
							tempAry.push(data[i]);
						}
					}
					if(data[i].itcode != null && data[i].name != null && data[i].pinyin == null){
						if((data[i]&&data[i].name&&data[i].name.indexOf(filterStr)>=0) || (data[i]&&data[i].itcode&&data[i].itcode.indexOf(filterStr)>=0)){
							tempAry.push(data[i]);
						}
					}
					if(data[i].itcode != null && data[i].name != null && data[i].pinyin != null){
						if((data[i]&&data[i].name&&data[i].name.indexOf(filterStr)>=0) || (data[i]&&data[i].itcode&&data[i].itcode.indexOf(filterStr)>=0) || (data[i]&&data[i].name&&data[i].pinyin.indexOf(filterStr)>=0)){
							tempAry.push(data[i]);
						}
					}
    		}
    		return tempAry;
    	}
    })
    app1.filter('face_match',function(){
    	return function(str){
    		//表情处理
    		var reg = new RegExp("\\[[^\\]]*\\]","g"); //创建正则RegExp对象
        	var faces = str.match(reg);
        	//#处理
        	var regJing = new RegExp("#[^#\\s&]*#","g"); //创建正则RegExp对象
        	var jings = str.match(regJing);
        	//@处理
        	var regAt = new RegExp("@[^@\\s&]*","g"); //创建正则RegExp对象
        	var ats = str.match(regAt);
        	if(faces != null){
        		for (var j=0;j<faces.length;j++) {
        			var imgPath = null;
        			var faceBase = ImgIputHandler.facePath;
        			for(var k=0;k<faceBase.length;k++){
        				var key = "[" + faceBase[k].faceName + "]";
        				if(key == faces[j]){//如果表情库的faceName等于匹配到的表情代码
        					imgPath = faceBase[k].facePath;
        					break;
        				}
        			}
        			if(imgPath == null){//如果没有找到表情

        			}else{
        				str = str.replace(faces[j], "<span class=\"" + imgPath +  "\"/>");//替换表情代码为表情图片链接
        			}
        		}
        	}
        	if(jings != null){
        		for (var m=0;m<jings.length;m++) {
        			str = str.replace(jings[m], "<a href='#'>"+jings[m]+"</a>");
        		}
        	}
        	if(ats != null){
        		for (var n=0;n<ats.length;n++) {
        			if(ats[n] != "@"){
        				str = str.replace(ats[n], "<a href='#'>"+ats[n]+"</a>");
        			}
        		}
        	}
        	return str;
    	}
    })

	//用在主页导航栏，增加空格
	// 半角：/u0020
	// 全角：/u3000
	app1.filter('iq_add_space', function () {
		return function (str) {
			if (str.length == 1){
				str = "\u3000\u0020"+str + "\u3000\u0020";
			}else if(str.length == 2){
				str = str[0] + "\u3000\u3000" + str[1];
			}else if(str.length == 3){
				str = str[0] +
					"\u0020" + str[1] +
					"\u0020" + str[2];
			}
			return str;
		}
	})

	//文件大小过滤器
	app1.filter('iq_file_size', function () {
		return function (str) {
			if(str<(1024*1024)){
				str = (str/1024.0).toFixed(0)+"KB";
			}else if(str>(1024*1024)&&str<1024*1024*1024){
				str = (str/(1024.0*1024.0)).toFixed(1)+"M";
			}else{
				str = ((str/(1024.0*1024.0))/1024.0).toFixed(1)+"G";
			}
			return str;
		}
	})

	app1.filter('titlecut',function(){
		return function (value, wordwise, max, tail) {
            if (!value) return '';

            max = parseInt(max, 10);
            if (!max) return value;
            if (value.length <= max) return value;

            value = value.substr(0, max);
            if (wordwise) {
                var lastspace = value.lastIndexOf(' ');
                if (lastspace != -1) {
                    value = value.substr(0, lastspace);
                }
            }

            return value + (tail || ' …');
        };
	})

	app1.filter('to_trusted_last', ['$sce', function($sce) {
		return function(text) {
			return $sce.trustAsHtml(text);
		}
	}])


})();
